module.exports = __webpack_public_path__ + "static/media/new_flight_meta_US_cover.6e13275b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/new_flight_meta_US_cover.png
// module id = 1439
// module chunks = 0